import {
  LoadingOutlined,
  TeamOutlined,
  UserOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import {
  Select,
  Card,
  Typography,
  Space,
  Tag,
  Spin,
  Empty,
  Button,
} from 'antd';
import { useClientes } from 'providers/ClientesProvider';
import React, { useEffect, useState } from 'react';

const { Title, Text } = Typography;
const { Option } = Select;

const TransferClientsForm = ({ value = [], onChange }) => {
  const {
    isLoading: loadingCli,
    activeData: clientes,
    hasCalled,
    call,
  } = useClientes();

  useEffect(() => {
    if (!hasCalled) {
      call();
    }
  }, [hasCalled, call]);

  const handleChange = (selectedValues) => {
    onChange(selectedValues);
  };

  const handleRemove = (clientId) => {
    const newValue = value.filter((id) => id !== clientId);
    onChange(newValue);
  };

  const getClientName = (clientId) => {
    const client = clientes?.find((c) => c.id === clientId);
    return client?.name || `Cliente ${clientId}`;
  };

  if (loadingCli) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Título y descripción */}
      <div className="text-center">
        <Title level={4} className="flex items-center justify-center">
          <TeamOutlined className="mr-2 text-blue-500" />
          Asignar Clientes
        </Title>
        <Text type="secondary" className="text-sm">
          Selecciona los clientes que serán asignados a este administrador
        </Text>
      </div>

      {/* Selector de clientes */}
      <Card className="shadow-sm">
        <div className="space-y-3">
          <div>
            <Text strong className="block mb-2">
              <UserOutlined className="mr-1" />
              Seleccionar Clientes
            </Text>
            <Select
              mode="multiple"
              placeholder="Buscar y seleccionar clientes..."
              value={value}
              onChange={handleChange}
              className="w-full"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              notFoundContent={
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No hay clientes disponibles"
                />
              }
            >
              {clientes?.map((cliente) => (
                <Option key={cliente.id} value={cliente.id}>
                  {cliente.name}
                </Option>
              ))}
            </Select>
          </div>

          {/* Clientes seleccionados */}
          {value && value.length > 0 && (
            <div>
              <Text strong className="block mb-2">
                <CheckCircleOutlined className="mr-1 text-green-500" />
                Clientes Asignados ({value.length})
              </Text>
              <div className="flex flex-wrap gap-2">
                {value.map((clientId) => (
                  <Tag
                    key={clientId}
                    closable
                    onClose={() => handleRemove(clientId)}
                    className="px-3 py-1 text-sm"
                    color="blue"
                  >
                    {getClientName(clientId)}
                  </Tag>
                ))}
              </div>
            </div>
          )}

          {/* Estado vacío */}
          {(!value || value.length === 0) && (
            <div className="text-center py-8">
              <TeamOutlined className="text-4xl text-gray-300 mb-2" />
              <Text type="secondary" className="block">
                No hay clientes asignados
              </Text>
              <Text type="secondary" className="text-xs">
                Usa el selector de arriba para asignar clientes
              </Text>
            </div>
          )}
        </div>
      </Card>

      {/* Información adicional */}
      <div className="text-center">
        <Text type="secondary" className="text-xs">
          💡 Tip: Puedes buscar clientes por nombre y seleccionar múltiples a la
          vez
        </Text>
      </div>
    </div>
  );
};

export default TransferClientsForm;
